import { render } from "./WonderLevel.vue?vue&type=template&id=6e5d540e"
import script from "./WonderLevel.vue?vue&type=script&lang=js"
export * from "./WonderLevel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__